import type { LeadDays } from 'uplisting-frontend/models/lead-time-rate-rule';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { LeadTimeRateRuleValidation } from 'uplisting-frontend/validations';

export default class LeadTimeRateRuleRepositoryService extends BaseRepositoryService<
  ModelRegistry['lead-time-rate-rule']
> {
  recordName = 'lead-time-rate-rule';
  implementMethods = ['buildChangeset', 'createRecord', 'peekAll', 'findAll'];

  validation = LeadTimeRateRuleValidation;

  ruleForDays(
    rules: ModelRegistry['lead-time-rate-rule'][],
    numberOfDays: LeadDays,
    property: ModelRegistry['property'],
  ): ModelRegistry['lead-time-rate-rule'] {
    return (
      rules.find((rule) => {
        return (
          rule.leadDays === numberOfDays && rule.property.id === property.id
        );
      }) ??
      this.createRecord({
        enabled: false,
        leadDays: numberOfDays,
        property,
      })
    );
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/lead-time-rate-rule': LeadTimeRateRuleRepositoryService;
  }
}
